import * as React from "react";

interface SearchFormProps {
    inputPlaceHolder?: string,
    formClassName?: string,
    showClearButton?: boolean,
    showSearchButton?: boolean,
    handleSearch: (value: string) => void
}

interface SearchFormState {
    value: string
}

export default class SearchForm extends React.Component<SearchFormProps, SearchFormState> {
    constructor(props: any) {
        super(props);
        this.state = {value: ""};
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event: any) {
        this.setState({value: event.target.value});
    }

    handleSubmit(event: any) {
        event.preventDefault();
        this.props.handleSearch(this.state.value)
    }

    handleClear = (event: any) => {
        event.preventDefault()
        this.setState({value: ""}, () => this.props.handleSearch(this.state.value));
    }

    render() {
        return (
            <form className={this.props.formClassName} onSubmit={this.handleSubmit}>
                <div className="search-patients-container">
                    <input type="text" value={this.state.value} onChange={this.handleChange} placeholder={this.props.inputPlaceHolder} className="brandon-bold">
                    </input>
                    <div className="search-icon-placeholder-container" onClick={this.handleSubmit}>
                        <img src="/images/icons/search-placeholder-icon.svg" />
                    </div>
                </div>
                {this.props.showSearchButton && (
                    <input type="submit" value="Search" className={"brandon-bold"} />
                )}
                {
                    this.props.showClearButton &&
                    <button onClick={this.handleClear} className={"brandon-bold"}>Clear</button>
                }
            </form>
        );
    }
}